import { Store } from 'bernie-plugin-mobx';
import { SerializedData } from 'bernie-core';
import { Sdk } from '__generated__/api';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

export class BaseBexApiStore extends Store {
  public readonly api: Sdk;

  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER, api: Sdk) {
    super(state, logger);
    this.api = api;
  }

  public hydrate(data: SerializedData) {
    Object.assign(this, { ...data, api: this.api, logger: this.logger });
  }

  public toJSON(ignoreAdditionalKeys: string[] | string = []) {
    const serializedState = super.toJSON(ignoreAdditionalKeys);

    if (serializedState?.bexApiSource?.headers) {
      delete serializedState.bexApiSource['headers'];
    }

    return serializedState;
  }
}
